import axios from 'axios'

import { endpoint } from '../config/api'

export const callGet = (url, token, params = {}, signal = undefined) => (
  axios.get(`${endpoint}${url}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    params,
    signal,
  })
)

export const callPost = (url, payload, token = '', signal = undefined) => {
  const headers = {}
  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  return axios.post(`${endpoint}${url}`, payload, {
    headers,
    signal,
  })
}
